export default __webpack_public_path__ + "static/media/google-play-btn.8555e950.png";